import PropTypes from "prop-types";


export default function FirefoxSectionTitle(props) {

    return (
        <div>
            <h2 className="custom-font mt-24 mx-auto max-w-4xl text-center text-4xl font-semibold tracking-tight text-white sm:text-5xl"
                style={{
                    color: props.textColor
                }}
            >
                {props.title}
            </h2>
            <p className="mx-auto mt-6  text-center text-lg text-gray-300" style={{
                color: props.textColor,
            }}>
                {props.blurb}
            </p>
        </div>
    )

}


FirefoxSectionTitle.propTypes = {
    textColor: PropTypes.string,

    // Copywritten content
    title: PropTypes.string,
    blurb: PropTypes.string,

}


FirefoxSectionTitle.defaultProps = {

    textColor: "#FFF",
    title: "What’s New on HerStory SEO?",
    blurb: "New tools for focus, privacy, and smoother mobile browsing.",
}